export const FEATURE_NAMESPACE = 'feature.instructions-and-documents'
